import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { Main, Posts, NotFound, Upload } from "../pages/index"; 
import './App.css';

class App extends Component {
  render() {
    const metaTag=document.createElement('meta');
    metaTag.name = "viewport"
    metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    document.getElementsByTagName('head')[0].appendChild(metaTag);
    return (
      <div className="App">
        <Switch>
          <Route path="/" exact={true} component={Main} />
          <Route path="/upload" exact={true} component={Upload} />
          <Route path="/booth/:boothId" exact={true} component={Posts} />
          <Route path="/booth/:boothId/upload" exact={true} component={Upload} />
          <Route component={NotFound} />
        </Switch>
      </div>
    );
  }
}

export default App;
